import { useContext, useState } from "react";
import styles from "./Kuda.module.css";
import { SupportEmail } from "../../common/SupportFooter";
import { Header } from "../../common/Header";
import { AmountSection } from "../../common/AmountSection";
import { RoutingContext } from "../../../context/Router";
import { MobileWrapper } from "../../common/MobileWrapper";
import { Details } from "./Details";
import { BackToMethods } from "../../common/BackToMethods";
import { WalletPayProps } from "../Wallet";
import axios from "axios";
import { sendMessage } from "../../../context/utils";
import { StatusContext } from "../../../context/Status";
import { StatusMessage } from "../../StatusMessage";
import { ErrorAlertContext } from "../../../context/ErrorAlert";

export const KudaMethod = () => {
  const { email, currency, amount, payData, merchantKey } =
    useContext(RoutingContext);
  const { onShowAlert } = useContext(ErrorAlertContext);
  const { setPageTransactionStatus } = useContext(StatusContext);

  const [isLoading, setIsLoading] = useState(false);
  const [tabDisplayed, setTabDisplayed] = useState("login");

  const onContinue = async (data?: WalletPayProps) => {
    const trimmedPhone = data?.phone ? data.phone.replace(/\s+/g, "") : "";

    let payload = {
      amount: amount,
      email: payData?.kit?.email,
      phone_number: trimmedPhone,
      country: "TZ",
      paymentType: payData?.kit?.paymentType,
      currency: payData?.currency,
      full_name: data?.fullname,
      pay_id: data?.kudaid,
      tx_ref: payData?.kit?.tx_ref,
      sourceCurrency: payData?.sourceCurrency,
      sourceAmount: payData?.kit?.sourceAmount,
    };

    if (
      payData.kit.extra &&
      ["baepay", "baepayapp"].includes(payData.kit.extra)
    ) {
      // @ts-ignore
      payload.extra = "baepay";
      // @ts-ignore
      payload.baeEmail = payData?.kit?.baeEmail;
    }

    try {
      setIsLoading(true);
      const response = await axios({
        method: "post",
        url: `${process.env.REACT_APP_API_URL}pay/kuda/initiate/payment`,
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          "x-auth-token": merchantKey,
        },
        data: payload,
      });
      const responseData = response.data;

      if (responseData.response_code === "00") {
        setTabDisplayed("success");
        setPageTransactionStatus("success");
        setTimeout(() => {
          sendMessage(responseData);
        }, 5000);
      } else if (responseData.status === null) {
        // addNewErrorMessage(responseData.message);
        return;
      } else if (responseData.status && data?.data?.response_code === "13") {
        // addNewErrorMessage(data?.data?.response_message);
        return;
      } else {
        setTabDisplayed("error");
        setPageTransactionStatus("error");
        responseData.status = "ERROR";
        setTimeout(() => {
          sendMessage(data);
        }, 5000);
      }
      setIsLoading(false);
    } catch (error) {
      onShowAlert(error, "Please try again");
      setIsLoading(false);
      setTabDisplayed("error");
      setPageTransactionStatus("error");
    }
  };

  if (tabDisplayed === "error" || tabDisplayed === "success") {
    return <StatusMessage type={tabDisplayed} />;
  }

  return (
    <MobileWrapper>
      <div className={styles.container}>
        <div className={styles.main}>
          <Header email={email} />
          <AmountSection amount={amount} currency={currency} />
          <div className={styles.body}>
            <Details
              onContinue={onContinue}
              defaultName={payData.kit.fullname}
              defaultPhone={payData.kit?.phone_number}
              isLoading={isLoading}
            />
          </div>
          <BackToMethods />
        </div>

        <SupportEmail />
      </div>
    </MobileWrapper>
  );
};
